import { useDateSegment } from "@react-aria/datepicker";
import {
	type DateFieldState,
	type DateSegment as DateSegmentInfo,
} from "@react-stately/datepicker";
import cx from "classnames";
import { type FC, useRef } from "react";

export const DateSegment: FC<{
	segment: DateSegmentInfo;
	state: DateFieldState;
	datePickerDialogTrigger: "manual" | "click";
	triggerDatePickerDialog: (() => void) | undefined;
	constantWidth: boolean;
}> = ({ segment, state, datePickerDialogTrigger, triggerDatePickerDialog, constantWidth }) => {
	const ref = useRef<HTMLDivElement>(null);
	const { segmentProps } = useDateSegment(segment, state, ref);

	let minWidth: string | undefined = undefined;
	if (constantWidth) {
		minWidth = segment.maxValue != null ? String(segment.maxValue).length + "ch" : undefined;
	}

	return (
		<div
			{...segmentProps}
			ref={ref}
			style={{ ...segmentProps.style, minWidth }}
			onKeyDown={(e) => {
				if (e.key === " ") {
					triggerDatePickerDialog?.();
				}
			}}
			onClick={datePickerDialogTrigger === "click" ? triggerDatePickerDialog : undefined}
			className={cx(
				`group box-content rounded-sm pr-0.5 text-right tabular-nums outline-none`,
				"focus:bg-brand focus:text-fixed-light-default",
				{
					"text-primary-disabled": state.isDisabled || !segment.isEditable,
					"text-primary": segment.isEditable,
				}
			)}
		>
			{/* Always reserve space for the placeholder, to prevent layout shift when editing. */}
			{segment.isPlaceholder && (
				<span
					aria-hidden="true"
					className={cx(
						"block w-full text-center italic group-focus:text-fixed-light-default",
						!state.isDisabled && "text-tertiary",
						state.isDisabled && "text-primary-disabled"
					)}
					style={{
						visibility: segment.isPlaceholder ? undefined : "hidden",
						height: segment.isPlaceholder ? "" : 0,
						pointerEvents: "none",
					}}
				>
					{segment.placeholder}
				</span>
			)}
			{segment.isPlaceholder ? "" : segment.text}
		</div>
	);
};
